// // IntegrationStack.jsx
// import { useRef } from "react";
// import { Link2 } from "lucide-react";

// const row1 = [
//   { name: "SAP",        logo: "https://cdn.hiview.ai/assets/images/SAP.svg" },
//   { name: "Oracle",     logo: "https://cdn.hiview.ai/assets/images/Oracle.svg" },
//   { name: "Shopify",    logo: "https://cdn.hiview.ai/assets/images/Shopify.svg" },
//   { name: "Salesforce", logo: "https://cdn.hiview.ai/assets/images/Salesforce.svg" },
//   { name: "EasyPost",   logo: "https://cdn.hiview.ai/assets/images/EasyPost.png" },
//   { name: "FedEx",      logo: "https://cdn.hiview.ai/assets/images/FedEx.svg" },
//   { name: "Slack",      logo: "https://cdn.hiview.ai/assets/images/Slack.svg" },
//   { name: "QuickBooks", logo: "https://cdn.hiview.ai/assets/images/QuickBooks.png" },
//   { name: "PostgreSQL", logo: "https://cdn.hiview.ai/assets/images/PostgreSQL.svg" },
//   { name: "BigQuery",   logo: "https://cdn.hiview.ai/assets/images/BigQuery.svg" },
//   { name: "Manhattan",  logo: "https://cdn.hiview.ai/assets/images/Manhattan.png" },
// ];

// const row2 = [
//   { name: "Snowflake",   logo: "https://cdn.hiview.ai/assets/images/Snowflake.svg" },
//   { name: "Databricks",  logo: "https://cdn.hiview.ai/assets/images/Databricks.png" },
//   { name: "Stripe",      logo: "https://cdn.hiview.ai/assets/images/Stripe.svg" },
//   { name: "SendGrid",    logo: "https://cdn.hiview.ai/assets/images/SendGrid.png" },
//   { name: "Mailchimp",   logo: "https://cdn.hiview.ai/assets/images/Mailchimp.png" },
//   { name: "MongoDB",     logo: "https://cdn.hiview.ai/assets/images/MongoDB.svg" },
//   { name: "NetSuite",    logo: "https://cdn.hiview.ai/assets/images/NetSuite.png" },
//   { name: "Metabase",    logo: "https://cdn.hiview.ai/assets/images/Metabase.png" },
//   { name: "Blue Yonder", logo: "https://cdn.hiview.ai/assets/images/BlueYonder.png" },
//   { name: "Microsoft",   logo: "https://cdn.hiview.ai/assets/images/Microsoft.svg" },
// ];

// function LogoCard({ name, logo }) {
//   return (
//     <div className="flex items-center mb-4 gap-2.5 bg-white border border-gray-100 rounded-2xl px-5 py-3.5 min-w-[150px] h-28 shrink-0">
//       <img
//         src={logo}
//         alt={name}
//         className="h-10 w-auto max-w-[150px] object-contain"
//         onError={(e) => (e.target.style.display = "none")}
//       />
//       {/* <span className="text-sm font-medium text-gray-500 whitespace-nowrap">{name}</span> */}
//     </div>
//   );
// }

// function MarqueeRow({ items, direction = "ltr" }) {
//   const doubled = [...items, ...items];
//   const animClass = direction === "ltr" ? "animate-marquee-ltr" : "animate-marquee-rtl";

//   return (
//     <div className="overflow-hidden relative w-full [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]">
//       <div className={`flex gap-3 w-max ${animClass} hover:[animation-play-state:paused]`}>
//         {doubled.map((item, i) => (
//           <LogoCard key={i} {...item} />
//         ))}
//       </div>
//     </div>
//   );
// }

// export default function IntegrationStack() {
//   return (
//     <section className="py-16 bg-gray-50">
//       {/* Header */}
//       <div className="text-center mb-10 px-4">
//         <div className="inline-flex items-center gap-2.5 mb-4">
//           <div className="w-12 h-12 rounded-xl bg-white border border-gray-200 flex items-center justify-center">
//             <Link2 size={26} className="text-gray-500" />
//           </div>
//           <h2 className="text-[2rem] sm:text-[2.5rem] font-extrabold text-gray-900 leading-tight mb-4 ">
//             Works With Your{" "}
//             <span className="text-orange-500">Existing Stack</span>
//           </h2>
//         </div>
//         <p className="text-sm max-w-md mx-auto leading-relaxed text-gray-500 mb-8">
//           Seamless integrations with 50+ ecosystem partners — connect with the tools you already use.
//         </p>
//       </div>

//       {/* Marquee rows */}
//       <div className="flex flex-col gap-3">
//         <MarqueeRow items={row1} direction="ltr" />
//         <MarqueeRow items={row2} direction="rtl" />
//       </div>
//     </section>
//   );
// }

// IntegrationStack.jsx
import { useRef } from "react";
import { Link2 } from "lucide-react";

const row1 = [
  { name: "SAP",        logo: "https://cdn.hiview.ai/assets/images/SAP.svg" },
  { name: "Oracle",     logo: "https://cdn.hiview.ai/assets/images/Oracle.svg" },
  { name: "Shopify",    logo: "https://cdn.hiview.ai/assets/images/Shopify.svg" },
  { name: "Salesforce", logo: "https://cdn.hiview.ai/assets/images/Salesforce.svg" },
  { name: "EasyPost",   logo: "https://cdn.hiview.ai/assets/images/EasyPost.png" },
  { name: "FedEx",      logo: "https://cdn.hiview.ai/assets/images/FedEx.svg" },
  { name: "Slack",      logo: "https://cdn.hiview.ai/assets/images/Slack.svg" },
  { name: "QuickBooks", logo: "https://cdn.hiview.ai/assets/images/QuickBooks.png" },
  { name: "PostgreSQL", logo: "https://cdn.hiview.ai/assets/images/PostgreSQL.svg" },
  { name: "BigQuery",   logo: "https://cdn.hiview.ai/assets/images/BigQuery.svg" },
  { name: "Manhattan",  logo: "https://cdn.hiview.ai/assets/images/Manhattan.png" },
];

const row2 = [
  { name: "Snowflake",   logo: "https://cdn.hiview.ai/assets/images/Snowflake.svg" },
  { name: "Databricks",  logo: "https://cdn.hiview.ai/assets/images/Databricks.png" },
  { name: "Stripe",      logo: "https://cdn.hiview.ai/assets/images/Stripe.svg" },
  { name: "SendGrid",    logo: "https://cdn.hiview.ai/assets/images/SendGrid.png" },
  { name: "Mailchimp",   logo: "https://cdn.hiview.ai/assets/images/Mailchimp.png" },
  { name: "MongoDB",     logo: "https://cdn.hiview.ai/assets/images/MongoDB.svg" },
  { name: "NetSuite",    logo: "https://cdn.hiview.ai/assets/images/NetSuite.png" },
  { name: "Metabase",    logo: "https://cdn.hiview.ai/assets/images/Metabase.png" },
  { name: "Blue Yonder", logo: "https://cdn.hiview.ai/assets/images/BlueYonder.png" },
  { name: "Microsoft",   logo: "https://cdn.hiview.ai/assets/images/Microsoft.svg" },
];

function LogoCard({ name, logo }) {
  return (
    <div className="flex items-center mb-4 gap-2.5 bg-white border border-gray-100 rounded-2xl px-3 sm:px-5 py-3.5 min-w-[130px] sm:min-w-[150px] h-24 sm:h-28 shrink-0">
      <img
        src={logo}
        alt={name}
        className="h-8 sm:h-10 w-auto max-w-[120px] sm:max-w-[150px] object-contain"
        onError={(e) => (e.target.style.display = "none")}
      />
      {/* <span className="text-sm font-medium text-gray-500 whitespace-nowrap">{name}</span> */}
    </div>
  );
}

function MarqueeRow({ items, direction = "ltr" }) {
  const doubled = [...items, ...items];
  const animClass = direction === "ltr" ? "animate-marquee-ltr" : "animate-marquee-rtl";

  return (
    <div className="overflow-hidden relative w-full [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)] sm:[mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]">
      <div className={`flex gap-2 sm:gap-3 w-max ${animClass} hover:[animation-play-state:paused]`}>
        {doubled.map((item, i) => (
          <LogoCard key={i} {...item} />
        ))}
      </div>
    </div>
  );
}

export default function IntegrationStack() {
  return (
    <section className="py-12 sm:py-16 bg-gray-50">
      {/* Header */}
      <div className="text-center mb-8 sm:mb-10 px-4">
        <div className="flex items-center justify-center gap-2.5 mb-3 sm:mb-4">
          <div className="w-10 h-10  rounded-xl bg-white border border-gray-200 hidden lg:flex items-center justify-center">
            <Link2 size={22} className="text-gray-500 sm:w-[26px] sm:h-[26px]" />
          </div>
           <h2 className="text-[1.75rem] sm:text-[2rem] md:text-[2.5rem] font-extrabold text-gray-900 leading-tight">
          Works With Your{" "}
          <span className="text-orange-500">Existing Stack</span>
        </h2>
        </div>
       
        <p className="text-xs sm:text-sm max-w-md mx-auto leading-relaxed text-gray-500 mb-6 sm:mb-8">
          Seamless integrations with 50+ ecosystem partners — connect with the tools you already use.
        </p>
      </div>

      {/* Marquee rows */}
      <div className="flex flex-col gap-2 sm:gap-3">
        <MarqueeRow items={row1} direction="ltr" />
        <MarqueeRow items={row2} direction="rtl" />
      </div>
    </section>
  );
}